import React, { useCallback, useEffect, useState } from 'react'
import { Tabs, TabPanel } from 'components/utility/Tabs'
import { useDispatch, useSelector } from 'react-redux'
import QuestionnaireAdminTabGeneral from 'components/QuestionnaireRequest/AdminNew/Tabs/General'
import QuestionnaireAdminTabPricing from 'components/QuestionnaireRequest/AdminNew/Tabs/Pricing'
import QuestionnaireAdminTabAdmins from 'components/QuestionnaireRequest/AdminNew/Tabs/Admins'
import { setInitialState } from 'components/QuestionnaireRequest/AdminNew/store/slice'

const tabsMapping = {
  general: QuestionnaireAdminTabGeneral,
  pricing: QuestionnaireAdminTabPricing,
  admins: QuestionnaireAdminTabAdmins,
}

export default function QuestionnaireAdminTabs(props) {
  const dispatch = useDispatch()
  const { tabs } = useSelector((state) => state.organizationQuestionnaireAdmin)
  const [activeIndex, setActiveIndex] = useState(0)
  const onChangeTab = useCallback((newIndex) => {
    setActiveIndex(newIndex)
  }, [])

  useEffect(() => {
    dispatch(
      setInitialState({
        enabled: props.organization.enable_questionnaires,
        questionnaireType: props.questionnaire_type,
        isAutoArchiveEnabled: props.organization.enable_auto_archive,
        isDisclaimerEnabled: props.organization.enable_disclaimer,
        disclaimerText: props.disclaimer_text,
        isGenericPreviewEnabled: props.organization.enable_generic_preview,
        genericFormPreviews: props.questionnaire_generic_settings,
        limitAcceptedFormTypes: props.limit_questionnaire_form_types,
        questionnaireAcceptedFormTypes: props.questionnaire_accepted_form_types,
        intakeSchedule: props.intake_schedule,
        // pricing
        isAutoPricingEnabled: props.organization.enable_auto_pricing,
        prices: props.prices,
        // emails
        adminEmails: props.adminEmails,
      })
    )
  }, [dispatch, props])

  return (
    <Tabs activeIndex={activeIndex} setActiveIndex={onChangeTab}>
      {tabs.map((tab) => {
        const Component = tabsMapping[tab.tab]

        return (
          <TabPanel key={tab.tab} label={tab.label}>
            <Component {...props} />
          </TabPanel>
        )
      })}
    </Tabs>
  )
}
